import React from "react";
import { Form, FormInstance, Input, Button, notification } from "antd";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "./style/Forgot.css";
import api from "../../../const/axios";
import { FrownOutlined, SmileOutlined, MailOutlined } from "@ant-design/icons";
import history from "./../../../const/history";

class Forgot extends React.Component<any> {
  formRef = React.createRef<FormInstance<any>>();
  
  state = {
    loading: false,
  };

  handleSubmit = async (values) => {
    this.setState({
      loading: true,
    });
    
    try {
      const res = await api.post("auth/forgot", JSON.stringify({ email: values.email }));
      
      if (res.data.success) {
        notification.info({
          message: this.props.t('auth.operationSuccess'),
          description: res.data.message,
          placement: "bottomRight",
          icon: <SmileOutlined />,
        });
        history.push("/");
      } else {
        notification.info({
          message: this.props.t('auth.operationFailed'),
          description: res.data.message,
          placement: "bottomRight",
          icon: <FrownOutlined />,
        });
      }
    } catch (error) {
      notification.error({
        message: this.props.t('auth.errorOccurred'),
        description: this.props.t('auth.operationError'),
        placement: "bottomRight",
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const { t } = this.props;
    
    return (
      <div className="b-container page">
        <div className="loginForm">
          <h3 className="page-name">{t('auth.resetPassword')}</h3>
          <Form ref={this.formRef} onFinish={this.handleSubmit} className="login-form">
            <Form.Item
              name="email"
              validateTrigger="onBlur"
              rules={[
                {
                  type: "email",
                  message: t('auth.emailInvalid'),
                },
                {
                  required: true,
                  message: t('auth.emailRequired'),
                },
              ]}
            >
              <Input
                prefix={
                  <MailOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />
                }
                placeholder={t('auth.email')}
              />
            </Form.Item>
            <Form.Item className="forgot-form-row">
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                style={{ width: "50%" }}
                loading={this.state.loading}
              >
                {t('auth.sendEmail')}
              </Button>
              <span style={{ marginTop: "-5px" }}>
                {t('common.or')} <Link to="/Login" className="fn">{t('auth.login')}</Link>
              </span>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Forgot);
